

































































































































































































































































































































































































































import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import {DialogForm, FormOverlay} from 'src/components/bwaff';
import ErrorAggregator from 'src/components/errors/error-aggregator.vue';
import HeaderButtons from 'src/components/ui/ui-modal/modal/header-buttons.vue'
import MetricsMixin from 'src/views/reports/pickers/base/metrics-mixin';
import { v4 as uuidv4 } from 'uuid';
import { GENERAL_PRESET } from '@/services/constants/report';
import UiButton from '@/components/ui/ui-button.vue';

// @ts-ignore
import Draggable from 'vuedraggable';
import UrlMixin from 'src/components/query/url-mixin';
import PickerBase from '../../base';
import ReportAPI from 'src/services/rest/bemob/report';

import {reportTypeFromRoute} from 'src/services/utils/reportType';
import _ from 'lodash';
import {isEqual} from 'lodash';
import ColumnsApi from 'src/services/rest/bemob/custom-columns';
import BemobApi from 'src/services/rest/bemob';
import ColumnSettingsApi from 'src/services/rest/bemob/column-settings';
import ColumnsGroupsSettingApi from 'src/services/rest/bemob/columns-groups-setting';

import ColumnsSettingsDialogMixin from '@/views/reports/pickers/cores/columns-settings-dialog/columns-settings-dialog-mixin';
import Vue from 'vue';
import ColumnsSettingsDialogColumn
  from '@/views/reports/pickers/cores/columns-settings-dialog/columns-settings-dialog-column.vue';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import Form, { Send } from '@/components/form-base';
import { AclMixin } from '@/components/acl/acl-mixin';
import store from '@/store';

const md5 = require('md5');
const columnSettingsApi: ColumnSettingsApi = new ColumnSettingsApi();
const columnsGroupsSettingApi: ColumnsGroupsSettingApi = new ColumnsGroupsSettingApi();


@Component({
  computed: {
    store() {
      return store
    }
  },
  components: {
    ColumnsSettingsDialogColumn,
    FormOverlay,
    DialogForm,
    ErrorAggregator,
    HeaderButtons,
    Draggable,
    ColumnsSettingsDialogMixin,
    PlanLimitsMixin,
  }
})
export default class ColumnsSettingsDialog extends mixins<MetricsMixin, Form, PickerBase, ColumnsSettingsDialogMixin,PlanLimitsMixin>(MetricsMixin, Form, PickerBase, ColumnsSettingsDialogMixin,PlanLimitsMixin) {
  oldSelectedMetricsHash: string = '';
  oldGroupOfMetricsHash: string = '';
  search: string = '';
  selectedMetrics: boolean[] = [];
  selectedMetricsPrevState: boolean[] = [];
  filteredMetricsGrouped: ColumnsGroup[] = [];
  groupingFromServer: { groups:{},columns:{}};
  orderedMetrics: Column[] = [];
  dragged: string = null;
  selectAll: boolean = false;
  reportApi: ReportAPI = new ReportAPI();
  bemobApi: BemobApi = new BemobApi();
  columnsApi: ColumnsApi = new ColumnsApi();
  inputPresetName:string ='';
  inputPresetNameNew:string ='';
  activePreset= this.$store.state.report.activePreset;
  isActivePresetWasUpdated=false;
  isActivePresetWasDropedToGeneral=false;
  GENERAL_PRESET=GENERAL_PRESET;
  presetSaveLoading: boolean = false;
  presetDeleteLoading: boolean = false;

  get pagesWithoutGrouping() {
    switch (this.$route.name) {
      case 'app.conversions':
      case 'app.postbacks':
      case 'app.errors':
      case 'app.live-clicks':
      case 'app.live-visits':
        return true;
      default: 
        return false
    }
  }

  get initSelectedMetrics() {
    return this.savedColumns.reduce((acc, column) => {
      const index = this.existing_metrics.findIndex(({value}) => value === column)
      acc[index] = true
      return acc
    }, [])
  }

  prepareOrderMetrics({isPrepareForReset}:{isPrepareForReset:Boolean}) {
    const newColumns = [];
    let oldColumns = isPrepareForReset ? [] : [...this.orderedMetrics];
  
    this.selectedMetrics.forEach((value,index) => {
      const metric = this.existing_metrics.find(metric => metric.index === index)
      if (value && !this.selectedMetricsPrevState[index]) {
        newColumns.push(metric)
      }
      
      if (!value && this.selectedMetricsPrevState[index]) {
        oldColumns = oldColumns.filter(item=>item.value !== metric.value)
      }
    })
    this.selectedMetricsPrevState = [...this.selectedMetrics]
    return [...oldColumns,...newColumns]
  }

  set orderedMetricsTree(val: any) {
    this.orderedMetrics = val.filter(({ isTreeColumn }) => !isTreeColumn)
  }

  columnHandleDragEnd(val: any) {
    this.recalculateSelectedInGroup();
  }

  clickNewPreset() {
    this.inputPresetNameNew= ''
    this.resetErrors();
    const openMenu = ()=>{
      const buttonRef = this.$refs.newPreset as UiButton;
      buttonRef.toggleMenu()
    }
    
    if(this.oldSelectedMetricsHash === this.getCurrentSelectedMetricsHash()){
      openMenu()
    }else{
      this.bus.emit('open-dialog', {
        name: 'ConfirmDialog',
        data: {
          title: this.t('Save changes'),
          message: this.t('Press OK to save the changes to this preset and move to the settings for the other preset.'),
          onConfirm: () => this.saveColumns(false, true).then(openMenu)
        }
      })
    }
  }
  
  selectPreset({ presetId, presetName }:{ presetId:string, presetName:string }) {
    this.resetErrors();
    if(presetId===this.activePreset) return;
    const switchPreset = ()=>{
      this.inputPresetName= presetName;
      this.activePreset = presetId;
      this.init()
    }
    if(this.oldSelectedMetricsHash === this.getCurrentSelectedMetricsHash()){
      switchPreset()
    }else{
      this.bus.emit('open-dialog', { 
        name: 'ConfirmDialog',
        data: {
          title: this.t('Save changes'),
          message: this.t('Press OK to save the changes to this preset and move to the settings for the other preset.'),
          onConfirm: () => this.saveColumns(false, true).then(switchPreset) 
        }
      })
    }  
  }

  @Send(true)
  savePreset({ ref, index, presetId }:{ ref?:string, index?:string | number, presetId?:string }){
    if(presetId && this.inputPresetName === this.$store.getters.activePresetData.presetName) {
      this.closeMenuPreset({index,ref})
      return
    }
    const inputPresetName = presetId ? this.inputPresetName : this.inputPresetNameNew
    this.presetSaveLoading = true;
    let newPresetId = null;
    if(!presetId){
      newPresetId = uuidv4()
    }
    const presetIdFinal = presetId || newPresetId;
    const presetData = presetId
      ? this.$store.state.reportColumns.savedColumns[this.activePreset]
      : this.defaultPresetState;

    const presetDataServerFormat = (Object.values(presetData) as ColumnsSettingsContext[]).reduce((acc,item)=>{
      const {context, order, columns,width} = item;
  
      acc.push({
        context,
        order,
        columns:columns.map((column)=>({
          name:column,
          width:width[column]
        }))
      })
      return acc;
    },[]) as ColumnsSettingsContextServerFormat[]

    return columnSettingsApi.putColumnSettings({
      id:presetIdFinal,
      name: inputPresetName,
      settings: presetDataServerFormat
    }).then(()=> {
      if(!presetId){
        this.activePreset = newPresetId;
        this.inputPresetName= inputPresetName;
      }

      this.$store.commit('updatePreset', { presetId: presetIdFinal, presetData });
      
      const presetsInfo = [...this.$store.state.report.presets];
      if(presetId){
        presetsInfo[presetsInfo.findIndex(item=>item.presetId===presetIdFinal)].presetName = inputPresetName
      }else{
        presetsInfo.push({
          presetId:newPresetId,
          presetName:inputPresetName
        })
      }
      this.$store.commit('setPresetsInfo', presetsInfo)
      this.closeMenuPreset({index,ref})
      this.init()

      this.bus.emit('toast-success', 
        presetId 
          ?  this.t('Preset name has been changed') 
          : this.t('Preset has been saved')
      )
    }).finally(()=>{
      this.presetSaveLoading = false;
    })
      
  }
  
  deletePreset({ presetId, index }){
    this.presetDeleteLoading = true;
    columnSettingsApi.deletePreset(presetId).finally(()=>{
      this.$store.commit('deletePreset', { presetId});
      if(this.$store.state.report.activePreset === presetId){
        this.$store.commit('setActivePreset', GENERAL_PRESET);
        this.isActivePresetWasDropedToGeneral = true;
      }
      this.activePreset = GENERAL_PRESET;
      this.init()
      
      const presetsInfo = [...this.$store.state.report.presets];
      presetsInfo.splice(presetsInfo.findIndex(item=>item.presetId===presetId), 1);
      this.$store.commit('setPresetsInfo', presetsInfo)
      
      this.presetDeleteLoading = false;
      this.closeMenuPreset({index})

      this.bus.emit('toast-success', this.t('Preset has been deleted'))
    })
  }

  closeMenuPreset({ ref, index }:{ ref?:string, index?:number|string }){
    if(ref){
      const buttonRef = this.$refs[ref] as UiButton;
      buttonRef.toggleMenu()
    }    
    if(index){
      this.$refs.presetsRefs[index].toggleMenu()
    }
  }

  isGroupSelected(groupData) {
    const allMetricsWithoutLimitsInGroup = this.getAllMetricsWithoutLimitsInGroup(groupData).length
    if(groupData.group.selected === 0) return false;
    
    return groupData.group.selected >= allMetricsWithoutLimitsInGroup
  }

  get orderedMetricsTree() {
    const { groupBy } = this.$store.getters.reportParams
    const { dimensions } = this.$store.state.reportColumns

    let treeColumns = []
    if (!this.isTreeView && this.isReport() && !['errors','postbacks','conversions', 'live-clicks', 'live-visits'].includes(groupBy)) {
      const groupByArray  = typeof groupBy==='string' ? [groupBy] : groupBy;
      treeColumns = groupByArray.map(key => dimensions[key].mainColumn) || []
    }
    const mainColumns = treeColumns.map(key => ({
      ...this.existing_metrics.find(({ value }) => value === key),
      isTreeColumn: true
    })) || [];

    const restColumns = this.orderedMetrics?.filter(({ value }) => !treeColumns.includes(value)) || []

   return [...mainColumns, ...restColumns]
  }

  init() {
    this.search='';
    this.selectedMetrics = this.initSelectedMetrics;
    this.selectedMetricsPrevState = [...this.selectedMetrics];
    
    this.groupingFromServer = this.$store.state.reportColumns.savedGroups

    this.orderedMetrics = this.savedColumns
      .map(key => this.filteredMetrics.find(({ value }) => value === key))
      .filter(item => item)
    
    this.checkSelectedAll();

    this.oldSelectedMetricsHash = this.getCurrentSelectedMetricsHash()
    
    this.calculateFilteredMetricsGrouped();
    this.recalculateSelectedInGroup();
    this.oldGroupOfMetricsHash = this.getCurrentGroupOfMetricsHash()
  }

  mounted() {
    this.inputPresetName = this.$store.getters.activePresetData.presetName
    this.init()
    this.bus.on('update-custom-columns', this.onUpdateCustomColumns);
  }

  beforeDestroy() {
    this.bus.off('update-custom-columns', this.onUpdateCustomColumns);
  }

  onUpdateCustomColumns({ action,item,groupIndex }){
    if(action==='add'){
      const customColumnsGroup = this.filteredMetricsGrouped.find(groupInstance=>groupInstance.group.id==='custom_columns');
      const column = this.existing_metrics.find(metric=>metric.id===item.id)
      this.selectedMetrics.splice(column.index, 0, false);
      this.selectedMetricsPrevState = [... this.selectedMetrics]
      customColumnsGroup.columns.push(column);
      customColumnsGroup.group.isOpened = true;
    }
    if(action==='edit'){
      const column = this.existing_metrics.find(metric=>metric.id===item.id)
      const columnIndexToReplace = this.filteredMetricsGrouped[groupIndex].columns.findIndex(metric=>metric?.id===item.id);
      Vue.set(this.filteredMetricsGrouped[groupIndex].columns, columnIndexToReplace, column);
    }

    if(action==='remove' || action === 'add'){
      // update metrics indexes
      const existing_metricsObject = this.existing_metrics.reduce((acc, metric) => {
        acc[metric.value] = metric;
        return acc;
      }, {})
      this.filteredMetricsGrouped.forEach(group=>group.columns.forEach(column=>column.index=existing_metricsObject[column.value].index))

      this.recalculateSelectedInGroup();
    }
  }
  
  getAllMetricsWithoutLimitsInGroup(groupData){
    return groupData.columns.filter(item=>!this.hasPlanLimitsRestriction(item.planLimits))
  }
  
  get getAllExistingMetricsWithoutLimits(){
    return this.existing_metrics.filter(item=>!this.hasPlanLimitsRestriction(this.getPlanLimits(item)))
  }
  
  get savedColumns(){
    const { groupBy } = this.$store.getters.reportParams
    const type = Array.isArray(groupBy) ? groupBy[0] : groupBy

    return this.allSavedColumns?.[type]?.columns || []
    
  }
  
  get allSavedColumns(){
    return this.$store.state.table.activeTab
      ? this.$store.getters.getColumns
      : this.$store.state.reportColumns.savedColumns[this.activePreset]
  }

  checkSelectedAll() {
    const newSelectAll = this.selectedLength === this.getAllExistingMetricsWithoutLimits.length;

    if(this.selectAll !== newSelectAll) {
      this.selectAll = newSelectAll;
    }
  }

  selectedMetricsChanged({ item, groupIndex }:{item?:Column, groupIndex?:number}={}) {
    this.orderedMetrics = this.prepareOrderMetrics({isPrepareForReset:false})
    this.checkSelectedAll()
    this.recalculateSelectedInGroup({ item, groupIndex });
  }

  recalculateSelectedInGroup({ item, groupIndex }:{item?:Column, groupIndex?:number}={}) {
    if(this.pagesWithoutGrouping) return;
    
    // clicked 1 column or initialization.
    if(item &&  typeof groupIndex !== 'undefined') {
      const newValue = this.filteredMetricsGrouped[groupIndex].group.selected + (this.selectedMetrics[item.index] ? +1 : -1);
      Vue.set(this.filteredMetricsGrouped[groupIndex].group,'selected',newValue)
      return
    }
    
    // clicked select all in group
    if(!item && typeof groupIndex !== 'undefined') {
      const groupInstance = this.filteredMetricsGrouped[groupIndex]
      let selected = 0

      const updateSelected = (column)=>{
        if(this.selectedMetrics[column.index]){
          selected = selected +1
        }
      }
      groupInstance.columns.forEach(column=>updateSelected(column))
      Vue.set(this.filteredMetricsGrouped,groupIndex,{
        ...groupInstance,
        group:{
          ...groupInstance.group,
          selected
        }

      })
      return
    }
    
    // clicked 'select all' or initialization. Recalculate all
    this.filteredMetricsGrouped = this.filteredMetricsGrouped.map((groupInstance,index)=>{
      let selected = 0
      
      const updateSelected = (column)=>{
        if(this.selectedMetrics[column.index]){
          selected = selected +1
        }
        
      }

      groupInstance.columns.forEach(column=>updateSelected(column))
      return {
        ...groupInstance,
        group:{
          ...groupInstance.group,
          selected
        }
        
      }
    })
    
  }

  isDisplayColumn (item) {
    return !(this.isTreeView && item.export);
  }

  get isTreeView() {
    return this.$store.getters.reportParams.view === 'tree';
  }

  get filteredMetrics():Column[] {
    return this.existing_metrics
      .filter((item: any) => this.reportMetricsName(item.text).toLowerCase().includes(this.search.toLowerCase()))
      .map((item)=>{
        return {
          ...item,
          planLimits:this.getPlanLimits(item)
        }
      });
  } 

  calculateFilteredMetricsGrouped() {
    if(this.pagesWithoutGrouping) return;
    const getDefaultGroup = (column)=>(column.isCustomColumn || column.value.startsWith('reports-customevent') ? 'custom_columns' : 'general')
    
    const filteredMetricsGroupObject = this.filteredMetrics.reduce((acc,item)=>{
      const groupIdFromServer = this.groupingFromServer.columns?.[item.value]?.groupId
      const columnSortIndexFromServer = this.groupingFromServer.columns?.[item.value]?.index

      const groupId = groupIdFromServer ||  getDefaultGroup(item)
      if(!acc[groupId]){
        acc[groupId] = {columnWithSavedIndex:[],columnWithoutSavedIndex:[],disabledColumns:[]}
      }
      
      if(item.disabled){
        if(!acc['general']){
          acc['general'] = {columnWithSavedIndex:[],columnWithoutSavedIndex:[],disabledColumns:[]}
        }
        acc['general'].disabledColumns.push(item)
      }
      if(typeof columnSortIndexFromServer === 'undefined'){
        acc[groupId].columnWithoutSavedIndex.push(item)
      }else{
        acc[groupId].columnWithSavedIndex[columnSortIndexFromServer] = item;
      }
      return acc;
    }, {}) as {
      [type: string] : {
        columnWithSavedIndex:Column[]
        columnWithoutSavedIndex:Column[]
        disabledColumns:Column[]
      }
    }
    
    // add empty groups
    Object.keys(this.$store.state.reportColumns.savedGroups.groups).forEach((groupId)=>{
      if(!filteredMetricsGroupObject[groupId]){
        filteredMetricsGroupObject[groupId] = {
          columnWithSavedIndex:[],
          columnWithoutSavedIndex:[],
          disabledColumns:[]
        }
      }
    })

    let groupsWithIndexArray = []
    let groupsWithoutIndexArray = [];
    let reCreatedGeneralGroup = []
    Object.keys(filteredMetricsGroupObject).forEach((groupKey)=>{
      const isOpened = this.groupingFromServer.groups?.[groupKey]?.isOpened
      const groupInstance = {
        group: {
          ...this.groupingFromServer.groups?.[groupKey],
          id:groupKey,
          isOpened: typeof isOpened === 'undefined' ? true : isOpened 
        },
        disabledColumns: filteredMetricsGroupObject[groupKey].disabledColumns,
        columns:[...filteredMetricsGroupObject[groupKey].columnWithSavedIndex,...filteredMetricsGroupObject[groupKey].columnWithoutSavedIndex].filter((item)=>item)
      }
      const groupIndexFromServer = this.groupingFromServer?.groups?.[groupKey]?.index
      
      // need to recreate general
      if(groupKey==='general' && typeof groupIndexFromServer === 'undefined'){
        return reCreatedGeneralGroup[0] = groupInstance
      }
      if(typeof groupIndexFromServer !== 'undefined'){
        return groupsWithIndexArray[groupIndexFromServer] = groupInstance
      }
      
      return groupsWithoutIndexArray.push(groupInstance)
    })

    this.filteredMetricsGrouped = [...reCreatedGeneralGroup,...groupsWithIndexArray.filter((item)=>item),...groupsWithoutIndexArray]
  }

  getCurrentSelectedMetricsHash() {
    return md5(JSON.stringify(this.orderedMetricsTree.map(item => item.value)));
  }

  getCurrentGroupOfMetricsHash() {
    return md5(JSON.stringify(this.filteredMetricsGroupedToSend));
  }

  getHelp(item: any, helpFull: boolean = false) {
    return helpFull ? item.helpFull : item.help
  }

  handleSelectAllChanged(value: boolean) {
    const { groupBy } = this.$store.getters.reportParams
    const { dimensions } = this.$store.state.reportColumns
    const types = (Array.isArray(groupBy) ? groupBy : [groupBy])?.map(key => dimensions[key]?.mainColumn)

    this.selectedMetrics = this.existing_metrics.reduce((acc, item) => {
      if(this.hasPlanLimitsRestriction(this.getPlanLimits(item))){
        acc.push(false)
      }else{
        acc.push(item.disabled || types?.includes(item.value) ? true : value)
      }
      
      return acc
    }, [])
    
    this.selectedMetricsChanged();
  }

  handleSelectAllInGroup(groupIndex: number) {
    const groupData = this.filteredMetricsGrouped[groupIndex]
    const newColumnValue = groupData.group.selected !== this.getAllMetricsWithoutLimitsInGroup(groupData).length;
    
    let newSelectedMetrics = [...this.selectedMetrics];
    this.filteredMetricsGrouped[groupIndex].columns.forEach(column=>{
      if(column.disabled){
       return  newSelectedMetrics[column.index] = true;
      }
      
      newSelectedMetrics[column.index] = this.hasPlanLimitsRestriction(column.planLimits) ? false : newColumnValue
    })
    this.selectedMetrics = newSelectedMetrics;
    this.selectedMetricsChanged({groupIndex});
  }

  get selectedLength() {
    return this.orderedMetricsTree.filter(item => item).length;
  }

  handleDragStart(event: any) {
    this.dragged = event.item.dataset.value;
  }

  handleDragEnd() {
    this.dragged = null;
  }

  onAddNewColumn(item,groupIndex) {
    this.bus.emit('open-dialog', { name: 'AddNewColumnDialog', data: { item, groupIndex, inheritMetrics: this.existing_metrics  }})
  }

  onDelete(item, groupIndex) {
    const { id, index, value } = item;
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
        message: this.t('All selected items will be deleted permanently if you press OK.'),
        onConfirm: () => {
          this.columnsApi.delete(id).then(() => {
            Promise.all([this.reportApi.getSupportedMetrics(), this.bemobApi.getCustomColumns()]).then(() => {
              const newColumnsValue = [...this.filteredMetricsGrouped[groupIndex].columns];
              const columnIndexToRemove = newColumnsValue.findIndex(column=>column?.id===item.id);
              newColumnsValue.splice(columnIndexToRemove, 1)
              Vue.set(this.filteredMetricsGrouped[groupIndex], 'columns', newColumnsValue);

              const columnIndexInOrdered = this.orderedMetrics.findIndex(metric=>metric.value===item.value);
              if(this.selectedMetrics[item.index]){
                this.orderedMetrics.splice(columnIndexInOrdered, 1);
              }
              this.selectedMetrics.splice(index, 1);
              this.selectedMetricsPrevState = [... this.selectedMetrics]
              
              this.bus.emit('update-custom-columns',{
                item,
                action:'remove',
                groupIndex
              });
              this.$store.dispatch('omitReportsColumns', [value])
            })

            this.bus.emit('toast-success', this.t('The custom column will be permanently deleted with all its calculated data.'))
          })
        },
      }})
  }

  get hasNewColumnBtn() {
    return ['campaigns', 'offers', 'landings', 'flows', 'traffic-sources', 'affiliate-networks'].includes(this.$route.params.type)
  }

  resetDefaults() {
    this.selectedMetricsPrevState = [];
    this.selectedMetrics = this.getDefaultSelected().reduce((acc, { index }) => {
      acc[index] = true
      return acc
    }, [])

    this.orderedMetrics = this.prepareOrderMetrics({isPrepareForReset:true})

    this.checkSelectedAll()
    this.recalculateSelectedInGroup();
  }

  resetResize(alternative: boolean) {
    const inheritColumns = this.getInheritColumns(alternative);

    const dimensions = this.tableFullDimensions
    const { groupBy } = this.$store.getters.reportParams

    const contexts = inheritColumns ? Object.keys(this.allSavedColumns) : [groupBy]

    const payload = contexts.map(context => {
      const { mainColumn } = dimensions[context] || {}
      const { width, order } = this.allSavedColumns[context]

      const resetKeys = Object.keys(width)

      const columnsWidth = resetKeys.map(key => ({
        name: key,
        width: key === mainColumn ? 300 : 100,
      }))

      return {
        columns: columnsWidth,
        context,
        order,
      }
    }) as ColumnsSettingsContextServerFormat[]


    columnSettingsApi.putColumnSettings({
      id:this.activePreset,
      name:this.inputPresetName,
      settings:payload
    }).finally(() => {
      this.$store.dispatch('patchSavedColumns', { 
        presetId:this.activePreset,
        presetDataServerFormat:payload
      })
      this.bus.emit('reset-table-width')
      this.bus.emit('toast-success', this.t('Column width reset successfully'));
    })
  }

  getResetResizeTitle(inheritColumns: boolean) {
    return inheritColumns ? this.t('Reset columns width for this section') : this.t('Reset columns width for all sections');
  }

  setIsOpenedGroup(key: string) {
    const groupOfColumns = this.filteredMetricsGrouped.find(item=>item.group.id === key)
    Vue.set(groupOfColumns.group, 'isOpened', !groupOfColumns.group.isOpened);
  }
  
  get filteredMetricsGroupedToSend(){
    return  this.filteredMetricsGrouped.map((groupInstance)=>{
      const {name, id:groupId, isOpened} = groupInstance.group;
      return {
        groupId,
        name,
        isOpened,
        columns:groupInstance.columns.map(item=>item.value)
      }
    });
  }

  submit(altertative: boolean = false) {
    // for chart
    this.$store.commit('tableClearChartHiddenSeries')

    const inheritColumns = this.getInheritColumns(altertative);

    if (this.oldGroupOfMetricsHash !== this.getCurrentGroupOfMetricsHash()) {
      columnsGroupsSettingApi.postColumnsGroupsSetting(this.filteredMetricsGroupedToSend).then(()=>{
        this.$store.dispatch('setGroupsColumns',this.filteredMetricsGroupedToSend)
        if (this.oldSelectedMetricsHash !== this.getCurrentSelectedMetricsHash()) {
          const inheritColumns = this.getInheritColumns(altertative);
          this.saveColumns(inheritColumns);
        }
      })
      this.close();
      return;
    }

    if (this.oldSelectedMetricsHash !== this.getCurrentSelectedMetricsHash()) {
      this.saveColumns(inheritColumns);
      this.close();
      return;
    }
    this.close();
  }

  getTableMetrics(type:string) {
    switch(type) {
      case 'postbacks':
        return this.postbacksMetrics.avaliable_metrics;
      case 'errors':
        return this.errorsMetrics.avaliable_metrics;
      case 'conversions':
        return this.conversionsMetrics.avaliable_metrics;
      case 'live-visits':
        return this.liveVisitsMetrics.avaliable_metrics;
      case 'live-clicks':
        return this.liveClicksMetrics.avaliable_metrics;
      default:
        return this.$store.state.reportColumns.metrics;
    }
  }

  sortColumns(columns, mainColumn, currentMainColumn) {
    const orderedMetricsValues = this.orderedMetricsTree.map(({ value }) => value)
    const valueWithoutMainColumn = orderedMetricsValues.filter((columnName: string) => columnName !== currentMainColumn)

    const sortIndex = columns.reduce((acc, columnName, index) => {
      // order collision resolution -- random
      acc[columnName] = valueWithoutMainColumn.findIndex((value) => value === columnName);
      if(acc[columnName] === -1 && columnName !== mainColumn) {
        acc[columnName] = index;
      }

      return acc
    }, {});

    return columns.sort((a, b) => { // mutate
      const aScore = sortIndex[a];
      const bScore = sortIndex[b];

      if(aScore > bScore) {
        return 1;
      } else if(aScore < bScore) {
        return -1;
      } else {
        return 0;
      }
    })
  }

  allAllowedMetricsOfDimension(dimension:string):{disabled: boolean,value: string,isTreeLevel?: boolean}[]{
    if(dimension==='conversions'){
      return this.existingMetricsCustom('app.conversions');
    }
    if(dimension==='postbacks'){
      return this.existingMetricsCustom('app.postbacks');
    }
    if(dimension==='errors'){
      return this.existingMetricsCustom('app.errors');
    }
    if(dimension==='live-clicks'){
      return this.existingMetricsCustom('app.live-clicks');
    }
    if(dimension==='live-visits'){
      return this.existingMetricsCustom('app.live-visits');
    }

    return this.getExistingMetricsSimple(dimension);
  }

  saveColumns(inheritColumns: boolean, dontCloseModal?:boolean) {
    this.$store.commit('loading', true);
    let newTableFilters;

    const { groupBy } = this.$store.getters.reportParams
    const contexts = inheritColumns ? Object.keys(this.allSavedColumns).filter(key => !['live-visits', 'live-clicks'].includes(key)) : [groupBy]

    const tableDimensions = this.tableFullDimensions;
    const type = reportTypeFromRoute();

    const tableMetrics  = this.getTableMetrics(type);

    const orderedMetricsValues = this.orderedMetrics.map(({ value }) => value)
    const currentTableMetrics = orderedMetricsValues.filter((columnName: string) => tableMetrics.includes(columnName));
    const currentUniqueTableMetrics = orderedMetricsValues.filter((columnName: string) => !tableMetrics.includes(columnName));
    const currentCustomTableMetrics = orderedMetricsValues.filter((columnName: string) => columnName.includes('reports-customevent'));

    const {
      additionalColumns: currentAdditionalColumns,
      mainColumn: currentMainColumn
    } = tableDimensions[type] || { mainColumn: null, additionalColumns: [] };

    const resultColumns = contexts.reduce((acc, dimension: string) => {
      const { mainColumn, additionalColumns } = tableDimensions[dimension] || { mainColumn: null, additionalColumns: [] };

      const inheritingTableMetrics = this.allSavedColumns[dimension].columns
      const sourceType = inheritColumns ? type : dimension;

      let result: any[] = inheritingTableMetrics

      if(this.isMetricAllowToInherit(inheritColumns, dimension, type)) {
        const commonAdditionalColumns = currentAdditionalColumns.filter((item: string) => additionalColumns.includes(item));
        const commonUniqueTableMetrics = currentUniqueTableMetrics.filter((columnName: string) => commonAdditionalColumns.includes(columnName))
        const allAllowedMetricsOfDimension = this.allAllowedMetricsOfDimension(dimension)
        const selectedAndDisabledAndNotTree = allAllowedMetricsOfDimension.filter(item=>item?.disabled===true && !item.isTreeLevel).map(item=>item.value);
 
        result = result
          .filter((item: any) =>
            !tableMetrics.includes(item) &&
            !commonAdditionalColumns.includes(item) &&
            !item.includes('reports-customevent') && 
            allAllowedMetricsOfDimension.find(metric=>metric.value===item) // delete not existed metric. ex if someone saved with API wrong metric
          )
          .concat(selectedAndDisabledAndNotTree)
          .concat(commonUniqueTableMetrics)
          .concat(currentTableMetrics)
          .concat(currentCustomTableMetrics)
        
        result = _.uniqBy(result, (column) => column);

        result = this.sortColumns(result, mainColumn, currentMainColumn)
      }

      let columnsContext: ColumnsSettingsContextServerFormat = {};
  
      const notSortableColumns = this.getCustomMetrics(this.dimensionType(dimension))?.sort_exclude;
      const sourceTypeSort = inheritColumns ? type : dimension;
      if(this.allSavedColumns[sourceTypeSort]?.order) {
        let sort: ColumnsSort = this.allSavedColumns[sourceTypeSort].order

        const currentSort = result.find((columnName) => columnName === sort.orderBy)
        
        if(!result.some((columnName) => columnName === sort.orderBy) || notSortableColumns.includes(currentSort)) {
          let oldSort: ColumnsSort = this.allSavedColumns[dimension]?.order
  
          if(inheritColumns && oldSort && result.some((columnName) => columnName === oldSort.orderBy) && !notSortableColumns.includes(currentSort)) {
            sort = oldSort;
          } else {
            sort = {
              orderBy: this.findOrderBy(result, dimension),
              orderDir: 'desc'
            }
          }
        }

        columnsContext.order = sort;
      }

      columnsContext = {
        ...columnsContext,
        context: dimension,
        columns: _.uniq(result).map((columnName: string) => {
          const width = _.get(this.allSavedColumns, [sourceType, 'width', columnName]) ||
            _.get(this.allSavedColumns, [dimension, 'width', columnName]) ||
            _.get(this.baseMetrics, ['metrics_options', columnName], columnName === mainColumn ? 300 : 100)
          const savedTotalType = this.allSavedColumns[dimension]?.totalType?.[columnName]
          return {
            name: columnName,
            width: Math.floor(width),
            ...(savedTotalType && {totalType : savedTotalType})
          } as ColumnsSettings
        })
      };

      if (type === dimension && this.activePreset === this.$store.state.report.activePreset) {
        const newTableFiltersValue = _.pick(this.$store.getters.tableColumnsFiltersForCurrentTab, result);
        if(!isEqual(newTableFiltersValue,this.$store.getters.tableColumnsFiltersForCurrentTab)){
          newTableFilters = newTableFiltersValue
        }
      }
      
      if (!!this.$store.state.table.activeTab) {
        acc.local.push(columnsContext)
      }
      if (!this.$store.state.table.activeTab || type === 'live-clicks' || type === 'live-visits') {
        if(this.isMetricAllowToInherit(inheritColumns, dimension, type)) {
          const {columnsFront, widthFront, totalTypeFront} = columnsContext.columns.reduce((acc,{name, width, totalType})=>{
            acc.widthFront[name] = width;
            acc.totalTypeFront[name] = totalType;
            acc.columnsFront.push(name);
            return acc;
          },{columnsFront :[], widthFront : {}, totalTypeFront : {}})
          acc.front[dimension]={
            ...columnsContext,
            columns:columnsFront, 
            width:widthFront,
            totalType:totalTypeFront,
          };
          if(this.allowToSaveThisMetricOnServer) {
            acc.server.push(columnsContext);
          }
        }

      }

      return acc
    }, {
      front: {
        ...this.defaultPresetState,
        ...this.allSavedColumns,
      },
      server: [], 
      local: [] 
    })

    if (type === 'live-visits' || type === 'live-clicks' || !this.$store.state.table.activeTab) {
      return columnSettingsApi.putColumnSettings({
        id:this.activePreset,
        name: this.inputPresetName,
        settings: resultColumns.server
      }).then(()=> {
        if(type === 'live-visits' || type === 'live-clicks'){
          this.$store.dispatch('setActiveReportColumns', resultColumns.local)
        }
        
        this.$store.commit('updatePreset', { 
          presetId: this.activePreset,
          presetData:resultColumns.front
        });
        
        if(newTableFilters){
          this.$store.commit('tableSetColumnsFilters', newTableFilters)
          this.bus.emit('update-table-filters');
        }

        this.$store.commit('loading', false);

        if(!dontCloseModal){
          this.close();
        }

        if((this.activePreset === this.$store.state.report.activePreset || this.isActivePresetWasUpdated || this.isActivePresetWasDropedToGeneral) && !dontCloseModal){
          this.bus.emit('reload-report')
        }

        if(this.activePreset === this.$store.state.report.activePreset){
          this.isActivePresetWasUpdated = true;
        }
      })
    }else{
      if (resultColumns.local.length) {
        this.$store.dispatch('setActiveReportColumns', resultColumns.local)
        this.close();
        this.bus.emit('reload-report')
      }
    }
  }

  get actions() {
    const isSpecialDimensions = this.isSpecialDimensions();
    return {
      newColumn: {
        key: 'newColumn',
        title: this.t('New Column'),
        icon: 'fas fas fa-plus',
        click: () => this.onAddNewColumn(null,null),
      },
      resetColumns: {
        key: 'resetColumns',
        title: this.t('Reset to defaults'),
        icon: 'fas fa-history',
        click: () => this.resetDefaults(),
      },
      resetResize: {
        key: 'resetResize',
        title: this.getResetResizeTitle(this.$store.state.user.independentColumnSettingsEnabled),
        icon: 'fas fa-history',
        click: () => this.resetResize(false),
        showCondition: !isSpecialDimensions
      },
      resetResizeAlternative: {
        key: 'resetResizeAlternative',
        title: this.getResetResizeTitle(!this.$store.state.user.independentColumnSettingsEnabled),
        icon: 'fas fa-history',
        click: () => this.resetResize(true),
        showCondition: !isSpecialDimensions
      },
      resetResizeComplex: {
        key: 'resetResizeAlternative',
        title: this.t('Reset columns width'),
        icon: 'fas fa-history',
        click: () => this.resetResize(false),
        showCondition: isSpecialDimensions
      },
      apply: {
        key: 'apply',
        title: `${this.t('Apply')} ${this.selectedLength || ''}`,
        icon: 'fas fa-check',
        click: () => this.submit(),
        showCondition: !isSpecialDimensions
      },
      applyAlternative: {
        key: 'applyAlternative',
        title: !this.$store.state.user.independentColumnSettingsEnabled
          ? this.t('Apply to this section')
          : this.t('Apply to all sections'),
        icon: 'fas fa-check',
        click: () => this.submit(true),
        showCondition: !isSpecialDimensions
      },
      applyComplex: {
        key: 'apply',
        title: `${this.t('Apply')} ${this.selectedLength || ''}`,
        icon: 'fas fa-check',
        click: () => this.saveColumns(false),
        showCondition: isSpecialDimensions
      },
    };
  }

  get applyMenuList(): Bemob.ListItem[] {
    return [
      this.actions.apply,
      this.actions.applyAlternative,
      this.actions.applyComplex,
    ].filter((item) => !!item.showCondition);
  }

  get resetMenuList(): Bemob.ListItem[] {
    return [
      this.actions.resetColumns,
      ...this.resetResizeMenuList
    ];
  }

  get resetResizeMenuList(): Bemob.ListItem[] {
    return [
      this.actions.resetResize,
      this.actions.resetResizeAlternative,
      this.actions.resetResizeComplex,
    ].filter((item) => !!item.showCondition);
  }

  checkClose() {
    if (this.oldSelectedMetricsHash !== this.getCurrentSelectedMetricsHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close');

    if(this.isActivePresetWasDropedToGeneral){
      this.$store.commit('tableSetColumnsFilters', {})
      this.bus.emit('update-table-filters');
      this.bus.emit('reload-report')
    }
    if(this.isActivePresetWasUpdated){
      this.bus.emit('reload-report')
    }
  }
  
  openDeletePresetDialog({ presetId, index }) {
    this.closeMenuPreset({index})
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('Selected preset will be deleted if you press OK.'),
      onConfirm: () => this.deletePreset({ presetId, index }),
    }})
  }
}
